import {
  MapTile,
  MapVectorTileEnum,
  MapProjection,
  MapProjectionEnum,
} from "@oreme/ui";

const tiles: MapTile[] = [
  {
    id: "OSMBright",
    title: "OSMBright",
    url: MapVectorTileEnum.OSMBright,
  },
  {
    id: "OSMOpenMapTiles",
    title: "OSM OpenMapTiles",
    url: MapVectorTileEnum.OSMOpenMapTiles,
  },
  {
    id: "Positron",
    title: "Positron",
    url: MapVectorTileEnum.Positron,
  },
  {
    id: "DarkMatter",
    title: "Dark Matter",
    url: MapVectorTileEnum.DarkMatter,
  },
  {
    id: "Toner",
    title: "Toner",
    url: MapVectorTileEnum.Toner,
  },
  {
    id: "JawgLight",
    title: "JawgLight",
    url: MapVectorTileEnum.JawgLight,
  },
  {
    id: "JawgSunny",
    title: "JawgSunny",
    url: MapVectorTileEnum.JawgSunny,
  },
  {
    id: "JawgDark",
    title: "JawgDark",
    url: MapVectorTileEnum.JawgDark,
  },
  {
    id: "JawgStreets",
    title: "JawgStreets",
    url: MapVectorTileEnum.JawgStreets,
  },
  {
    id: "JawgLagoon",
    title: "JawgLagoon",
    url: MapVectorTileEnum.JawgLagoon,
  },
  {
    id: "JawgTerrain",
    title: "JawgTerrain",
    url: MapVectorTileEnum.JawgTerrain,
  },
];

export const mapTiles: Map<string, MapTile> = new Map(
  tiles.map((item) => [item.id, item]),
);

const projections: MapProjection[] = [
  {
    id: MapProjectionEnum.GLOBE,
    title: "Globe",
  },
  {
    id: MapProjectionEnum.MERCATOR,
    title: "Mercator",
  },
];

export const mapProjections: Map<string, MapProjection> = new Map(
  projections.map((item) => [item.id, item]),
);
